import { CONTENT } from "@/content";
import { BorderBeam } from "@/components/ui/border-beam";

type Props = { onCTA: () => void };

export function Hero({ onCTA }: Props) {
  const h = CONTENT.hero;

  return (
    <section className="hero" id="top">
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-tex" />
        <div className="hero-vig" />
      </div>
      <div className="wrap hero-inner">
        <div className="hero-copy">
          <span className="eyebrow hero-eyebrow">{h.eyebrow}</span>
          <h1 className="hero-h">
            <span className="hero-title-line">Você já estudou </span>
            <span className="hero-title-line">
              <span className="kw kw-blue">inglês</span>, mas ainda{" "}
            </span>
            <span className="hero-title-line">
              <span className="kw kw-danger">
                trava<span className="kw-line" aria-hidden="true" />
              </span>{" "}
              na hora{" "}
            </span>
            <span className="hero-title-line">de falar?</span>
          </h1>
          <p className="hero-sub">{h.subhead}</p>
          <div className="hero-actions">
            <button className="btn btn-primary btn-lg btn-beam btn-beam-primary" onClick={onCTA}>
              <BorderBeam />
              {h.cta} <span className="arr">→</span>
            </button>
            {h.ctaNote && <span className="hero-note">{h.ctaNote}</span>}
          </div>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <div className="hero-laptop">
            <img
              className="hero-laptop-composite"
              src="/assets/hero-laptop-composite.png"
              alt=""
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
